function generateMedia(breakpoints) {
  // new methods for the upgraded @emotion/styled
  // based on this solution https://stackoverflow.com/a/65281378/7126766
  const lessThan = Object.entries(breakpoints).reduce((prev, [key, breakpoint]) => {
    prev[key] = `@media screen and (max-width: ${breakpoint - 1}px)`;
    return prev;
  }, {});

  const greaterThan = Object.entries(breakpoints).reduce((prev, [key, breakpoint]) => {
    prev[key] = `@media screen and (min-width: ${breakpoint}px)`;
    return prev;
  }, {});

  return Object.assign({
    lessThan,
    greaterThan,
  });
}

const breakpoints = {
  xxs: 375,
  xs: 576,
  sm: 768,
  md: 992,
  lg: 1200,
  xl: 1400,
  xxl: 1870,
};

const media = generateMedia(breakpoints);

export default media;
